import React from "react";
import BaseModal from "./BaseModal";
import { useBatchChangePublication } from "show/list/hooks/apis";
import PublicationDropdown from "components/dropdowns/reactselect/PublicationDropdown";

interface Props {
  mainArea: server.dto.MainAreas
  onClose: () => void
}

const ChangePublicationModal = (props: Props) => {
  const [selectedPublicationStatus, setSelectedPublicationStatus] = React.useState<server.dto.PublicationStatuses>();

  const changePublicationMutation = useBatchChangePublication();

  const applyChanges = async () => changePublicationMutation.mutateAsync(selectedPublicationStatus);

  return <BaseModal
    mainArea={props.mainArea}
    action="change"
    onClose={props.onClose}
    title={RESX.Planning.ChangePublishStatus}
    hasSelectedValue={selectedPublicationStatus != null}
    api={applyChanges}
  >
    <PublicationDropdown
      onChange={setSelectedPublicationStatus}
      value={selectedPublicationStatus}
      excludeKeys={[]}
      config={{}}
    />
  </BaseModal>;
};

export default ChangePublicationModal;